import { createContext, useContext } from "react";
import { type ProjectConfig, getProject } from "./projectConfig";

const ProjectContext = createContext<ProjectConfig>(getProject("e16-fas"));

export const ProjectProvider = ProjectContext.Provider;

/** Read the active project config from context */
export function useProject(): ProjectConfig {
  return useContext(ProjectContext);
}
